import ds from './DataSourceService'

const baseUrl = '/health'

const getStatus = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/status')
}

const getHistory = (target, limit) => {
  return ds.apiClientThinkHome.get(baseUrl + '/history', {
    params: { target, limit }
  })
}

const getIncidents = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/incidents')
}

const runCheck = () => {
  return ds.apiClientThinkHome.post(baseUrl + '/check/run')
}

const restartProcess = processName => {
  return ds.apiClientThinkHome.post(baseUrl + '/restart/' + processName)
}

const getRequestLogs = filters => {
  return ds.apiClientThinkHome.get(baseUrl + '/requests', { params: filters })
}

const getErrorLogs = filters => {
  return ds.apiClientThinkHome.get(baseUrl + '/errors', { params: filters })
}

const getAlertRecipients = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/config/alert-recipients')
}

const saveAlertRecipients = emails => {
  return ds.apiClientThinkHome.post(baseUrl + '/config/alert-recipients', {
    emails
  })
}

const getEmailsSuppressed = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/config/emails-suppressed')
}

const saveEmailsSuppressed = suppressed => {
  return ds.apiClientThinkHome.post(baseUrl + '/config/emails-suppressed', {
    suppressed
  })
}

export default {
  getStatus,
  getHistory,
  getIncidents,
  runCheck,
  restartProcess,
  getRequestLogs,
  getErrorLogs,
  getAlertRecipients,
  saveAlertRecipients,
  getEmailsSuppressed,
  saveEmailsSuppressed
}
